import { ReactNode } from "react";

import { Skeleton } from "components/Skeleton";

import * as S from '../styles'

export function InfoText({
  label,
  data,
  isLarge = false,
  icon,
}: {
  label?: string;
  data?: string;
  isLarge?: boolean;
  icon?: ReactNode;
}) {
  return (
    <S.InfoTextContainer isLarge={isLarge}>
      {label && <p>{label}</p>}

      <div className={`body ${icon && "iconed-text"}`}>
        {icon && <div>{icon}</div>}
        <span>{!data ? <Skeleton width={50} /> : data}</span>
      </div>
    </S.InfoTextContainer>
  );
}